import { render, staticRenderFns } from "./Presets.vue?vue&type=template&id=1fcfb4df&"
import script from "./Presets.vue?vue&type=script&lang=ts&"
export * from "./Presets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports